export default __webpack_public_path__ + "static/apple-touch-icon-152x152-6cfc9aaaade671f720dddbc1e99cb363.png";